export default __webpack_public_path__ + "static/media/type1.d69adeab.svg";